import * as React from 'react';

import styles from './dash-obfuscation.module.css';

type Props = {
    message: string;
};
export function DashObfuscation(props: Props) {
    return (
        <div className={styles.container}>
            <img
                src='/include/images/plan-pro/badge-pro.svg'
                className={styles['feature-pro-badge']}
            />
            <div className={styles.message}>{props.message}</div>
        </div>
    );
}
